import type { FunctionComponent } from 'react';

import { Logger } from '../../../../logger/Logger';
import { useCoreDispatch } from '../../../../store/CoreStore';
import { useAutoplayHiddenFlag } from '../../../../store/compositeSelectors/useAutoplayHiddenFlag';
import { useAutoplaySlice } from '../../../../store/slices/autoplay/selectors';
import { autoplayActions } from '../../../../store/slices/autoplay/slice';
import { useBetSlice } from '../../../../store/slices/bets/selectors';
import { Icons } from '../../../icons/iconNames';
import { GameButtonProps, GameButtonWithTooltip } from '../../gameButton/gameButton';

export interface AutoplayControlConnectedProps extends Omit<GameButtonProps, 'icon'> {}

export const AutoplayControlConnected: FunctionComponent<AutoplayControlConnectedProps> = ({ ...rest }) => {
  const dispatch = useCoreDispatch();
  const hideAutoplay = useAutoplayHiddenFlag();
  const totalBet = useBetSlice.totalBet();

  // AUTOPLAY
  const isInProgress = useAutoplaySlice.isInProgress();
  const isOpen = useAutoplaySlice.isOpen();
  const remainingCount = useAutoplaySlice.getRemainingCount();

  const toggleOpen = (): void => {
    dispatch(autoplayActions.toggleOpen());
    Logger.logEvent('click', 'autoplay', Date.now(), 1, '', false);
  };

  if (hideAutoplay) return null;
  return (
    <GameButtonWithTooltip
      data-testid="autoplay-button"
      icon={Icons.Autoplay}
      border
      active={isOpen}
      onClick={toggleOpen}
      grow
      disabled={!isInProgress && totalBet === 0}
      badge={isInProgress ? remainingCount : ''}
      {...rest}
      tooltipOptions={{
        text: isInProgress ? 'MODIFY_AUTOPLAY' : 'AUTOPLAY',
        disabled: isOpen,
      }}
    />
  );
};
